<template>
  <span name="state" v-if="!anyTransaction">
    <vs-chip class="ag-grid-cell-chip" :color="color">
      <span>{{ paramValue }}</span>
    </vs-chip>
  </span>
  <div v-else>
    <vs-chip class="ag-grid-cell-chip transform-6" color="success">
      <span
        >{{ getSuccessTransactionCount }}
        {{ $t("Table.Transactions.SuccessTransaction") }}</span
      >
    </vs-chip>
    <vs-chip class="ag-grid-cell-chip transform-6" :color="color">
      <span
        >{{ getFailedTransactionCount }}
        {{ $t("Table.Transactions.ErrorTransaction") }}</span
      >
    </vs-chip>
  </div>
</template>

<script>
export default {
  name: "CellTransactionState",
  data: {
    paramValue: "",
    color: "",
  },
  computed: {
    paramValue() {
      var extendPayText =
        this.$options.filters.currency(this.params.data.PaidAmount) + " ";
      return !this.anyTransaction
        ? extendPayText + this.$t("Table.Transactions.Status1")
        : this.$t("Table.Transactions.Status2");
    },
    anyTransaction() {
      return this.params.data.IsPaymentRequired.Need;
    },
    getSuccessTransactionCount() {
      return this.params.data.Invoice.Transactions
        ? this.params.data.Invoice.Transactions.filter(
            (x) => x.TransactionState == 0
          ).length
        : 0;
    },
    getFailedTransactionCount() {
      return this.params.data.Invoice.Transactions
        ? this.params.data.Invoice.Transactions.filter(
            (x) => x.TransactionState > 1
          ).length
        : 0;
    },
    color() {
      return !this.params.value ? "success" : "danger";
    },
  },
};
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success), 0.15);
    color: rgba(var(--vs-success), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning), 0.15);
    color: rgba(var(--vs-warning), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger), 0.15);
    color: rgba(var(--vs-danger), 1) !important;
    font-weight: 500;
  }
}
.ag-grid-cell-chip.transform-6 {
  transform: translateY(6%);
}
</style>
